export const VERSION = '0.5.2';
//# sourceMappingURL=version.js.map